import { createSlice } from '@reduxjs/toolkit';
import {
  AUTH_SLICE,
  loginSuccess,
  logout,
  setAllUsers,
  setAuthCheck,
  setLoginSuccess,
  setSupportInfo,
} from 'src/store/actions/authActions';

import { CheckUser, SupportInfo, User } from '../store/models/Auth';
import {
  localStorageHelper,
  sessionStorageHelper,
  StoragePrefix,
} from '../utils/localStorage';

export interface AuthState {
  user: User;
  loginSuccess: boolean;
  authCheck: CheckUser[];
  supportInfo?: SupportInfo;
}

const storageHelper = localStorageHelper?.get(StoragePrefix.REMEMBER_ME)
  ? localStorageHelper
  : sessionStorageHelper;

const initialState: AuthState = {
  user: storageHelper?.get(StoragePrefix.USER) || null,
  loginSuccess: false,
  authCheck: null,
  supportInfo: null,
};

const authSlice = createSlice({
  name: AUTH_SLICE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginSuccess, (state, action) => {
        const user = { ...state.user, ...action.payload };
        state.user = user;
      })
      .addCase(setLoginSuccess, (state, action) => {
        state.loginSuccess = action.payload;
      })
      .addCase(setAuthCheck, (state, action) => {
        state.authCheck = action.payload;
      })
      .addCase(setAllUsers, (state, action) => {
        if (state.user) {
          state.user.allUsers = action.payload;
        }
      })
      .addCase(setSupportInfo, (state, action) => {
        state.supportInfo = action.payload;
      })
      .addCase(logout, (state) => {
        state.user = null;
      });
  },
});

export default authSlice.reducer;
